module.exports = __webpack_public_path__ + "media/images/web/home/index/congress-994e2534cb924cec491a04f3f055c106.jpg";